import BaseStore from "@/modules/baseStore.js";
import BaseApi from "@/modules/baseApi.js";

const state = {
  O_inner: {},
  O_normal: {},
  O_check: {},

  stateRules: {
    inner: {
      endpointProps: ["normal"],
    },
  },
};

const api = BaseApi(state, "sample/arrival");

export default BaseStore.extend({
  state,
  api,
});
